import React from 'react'
import { userDetailsSelector } from '../../rdxsga/redux/slices/userSlice';
import { useSelector } from 'react-redux';
import { APP_URLS } from '../../config';
import { Navigate } from 'react-router-dom';
import FullScreenLayout from '../layout/FullScreenLayout';

function reqNoAuth(Component) {
    function HocLayoutNoAuth() {
        const user = useSelector(userDetailsSelector)
        // //console.log("user", user)
        return (
            !user.isAuthenticated ?
                <FullScreenLayout>
                    <Component />
                </FullScreenLayout> :
                <Navigate to={APP_URLS.DASHBOARD} />
        )
    }
    return <HocLayoutNoAuth />
}

export default reqNoAuth